import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'languageNativeName',
  standalone: true,
})
export class LanguageNativeNamePipe implements PipeTransform {
  transform(langCode: string | undefined): string {
    if (!langCode) {
      return '';
    }

    try {
      const targetLang = langCode.toLowerCase();
      const displayNames = new Intl.DisplayNames([targetLang], { type: 'language' });
      const name = displayNames.of(targetLang);

      return name ? name.charAt(0).toUpperCase() + name.slice(1) : langCode;
    } catch (err) {
      console.error({ err, scope: 'LanguageNativeNamePipe' });
      return langCode; // Safe fallback
    }
  }
}
